import React, { useCallback, useMemo, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { SuccessFilledIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { AiChatTestIds } from '../../../../AiChat.testIds';
import { TOOL_CONFIRMATION_LABELS } from '../../ToolConfirmationCard.constants';
import { anyValuePropType } from '../../ToolConfirmationCard.propTypes';
import {
  contentStyles,
  iconContainerStyles,
  resultFullStyles,
  resultTextStyles,
  showMoreButtonStyles,
  statusContainerStyles,
  successIconStyles,
} from '../../ToolConfirmationCard.styles';
import { formatToolResult, getResultSummary } from '../../ToolConfirmationCard.utils';

const ExecutedStatus = ({ result }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const onToggleClick = useCallback(() => {
    setIsExpanded(current => !current);
  }, []);

  const formattedResult = useMemo(() => formatToolResult(result), [result]);
  const { summary, hasMore } = useMemo(() => getResultSummary(formattedResult), [formattedResult]);

  return (
    <Box sx={statusContainerStyles}>
      <Box sx={iconContainerStyles}>
        <SuccessFilledIcon size={18} style={successIconStyles} />
      </Box>
      <Box sx={contentStyles}>
        <Typography
          data-testid={AiChatTestIds.TOOL_CONFIRMATION_CARD_RESULT}
          sx={isExpanded ? resultFullStyles : resultTextStyles}
          variant="regular12"
        >
          {isExpanded ? formattedResult : summary}
        </Typography>
        {hasMore ? (
          <Box
            component="button"
            data-testid={AiChatTestIds.TOOL_CONFIRMATION_CARD_RESULT_TOGGLE}
            sx={showMoreButtonStyles}
            type="button"
            onClick={onToggleClick}
          >
            {isExpanded ? TOOL_CONFIRMATION_LABELS.SHOW_LESS : TOOL_CONFIRMATION_LABELS.SHOW_MORE}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

ExecutedStatus.propTypes = {
  result: anyValuePropType,
};

export default ExecutedStatus;
